var dic = {
  state: {
    hasGetDic: false,
    // 庭审状态
    trailStatusList: [],
    // 学历
    educationList: [],
    // 案件年号
    yearList: [],
    // 案件代字
    caseCodeList: [],
    // 性别
    sexList: [],
    // 法庭类别
    tribunalTypeList: [],
    // 法庭规模
    tribunalScaleList: [],
    // 证件类型
    certificateTypeList: [],
    // 民族
    nationList: []
  },
  mutations: {
    SET_DIC: function SET_DIC(state, dicInfo) {
      state.hasGetDic = true;
      state.trailStatusList = dicInfo.trailStatusList || [];
      state.educationList = dicInfo.educationList || [];
      state.yearList = dicInfo.yearList || [];
      state.caseCodeList = dicInfo.caseCodeList || [];
      state.sexList = dicInfo.sexList || [];
      state.tribunalTypeList = dicInfo.tribunalTypeList || [];
      state.tribunalScaleList = dicInfo.tribunalScaleList || [];
      state.certificateTypeList = dicInfo.certificateTypeList || [];
      state.nationList = dicInfo.nationList || [];
    }
  },
  actions: {
    SetDic: function SetDic(_ref, dicInfo) {
      var commit = _ref.commit;
      commit('SET_DIC', dicInfo);
    }
  }
};
export default dic;